import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useSEO, buildBreadcrumbsJsonLd } from "../lib/seo";
import { COMPANY, SITE_URL } from "../lib/constants";
import { imageUrl } from "../lib/api";
import { catLabel, useArticle, useKbCategories } from "../lib/kennisbank";
import { ArticleView } from "../components/kennisbank/ArticleView";
import { KbRelated } from "../components/kennisbank/KbRelated";
import { AdviceEndCta } from "../components/info/AdviceBlocks";
import NotFound from "./NotFound";

const absolute = (path) => { const u = imageUrl(path); return u.startsWith("/") ? SITE_URL + u : u; };
export const articleTitle = (a) => a.seo_title || (`${a.title} | Maas Kozijn`.length <= 65 ? `${a.title} | Maas Kozijn` : a.title);

const articleLd = (a, cats) => ({
  "@context": "https://schema.org", "@type": "BlogPosting", headline: a.title, description: a.seo_description || a.excerpt,
  image: a.image?.path ? [absolute(a.image.path)] : undefined, datePublished: a.published_at, dateModified: (a.updated_at || a.published_at || "").slice(0, 10),
  articleSection: catLabel(cats, a.category) || undefined, inLanguage: "nl-NL", wordCount: (a.read_minutes || 2) * 200,
  author: { "@type": "Organization", name: COMPANY.name, url: SITE_URL },
  publisher: { "@type": "Organization", "@id": `${SITE_URL}/#localbusiness`, name: COMPANY.name, logo: { "@type": "ImageObject", url: `${SITE_URL}/logo-maas.png` } },
  mainEntityOfPage: { "@type": "WebPage", "@id": `${SITE_URL}/blog/${a.slug}` },
});

export default function BlogPost() {
  const { slug } = useParams();
  const a = useArticle(slug);
  const cats = useKbCategories();
  const ok = a && typeof a === "object";
  useSEO(ok ? {
    title: articleTitle(a), description: a.seo_description || a.excerpt, path: `/blog/${a.slug}`, ogImage: a.image?.path ? absolute(a.image.path) : undefined,
    jsonLd: articleLd(a, cats), breadcrumbs: buildBreadcrumbsJsonLd([{ label: "Home", href: "/" }, { label: "Kennisbank", href: "/blog" }, { label: a.title, href: `/blog/${a.slug}` }]),
  } : { title: "Kennisbank | Maas Kozijn", path: `/blog/${slug}`, noindex: a === "missing" });
  if (a === "missing") return <NotFound />;
  if (!ok) return <div className="flex min-h-[60vh] items-center justify-center" data-testid="kb-article-loading"><Loader2 className="h-6 w-6 animate-spin text-maas" /></div>;
  return (
    <div data-testid={`kb-article-page-${a.slug}`}>
      <ArticleView a={a} cats={cats} />
      <KbRelated category={a.category} onderwerp={a.onderwerp} exclude={a.slug} title="Lees ook" tone="slate" />
      <AdviceEndCta title="Klaar voor de volgende stap?" location="kb-article" onderwerp={a.onderwerp || undefined} />
    </div>
  );
}
